import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CustomFieldSelectList from "../../../../../connections/atlassian/jira/components/CustomFieldSelectList";
import { Collapse } from "antd";
import { TriggerType } from "../../../../../common/interfaces/flow/trigger/TriggerType";
import { Flex, Flex1 } from "../../../../../common/style";
import { Label } from "@atlaskit/form";

const MidSectionConnectionExtension = () => {
  const { Panel } = Collapse;
  const [value, setValue] = useState("");

  const flow = useSelector((state) => state.integration.flow);
  useEffect(() => {}, [flow]);

  const setCallbackValue = (callbackValue) => {
    setValue(callbackValue.value);
  };

  return (
    <>
      {flow.trigger?.type === TriggerType.ATLASSIAN_WEBHOOK_TRIGGER_TYPE && (
        <Collapse defaultActiveKey={[]} ghost>
          <Panel header="Helpers" key="1">
            <p>Select an Issue Field to view the mustache syntax for that field.</p>

            <Label>Issue field</Label>
            <CustomFieldSelectList onSelectField={setCallbackValue} />
            <br />
            {value && value !== "" && (
              <>
                <b>Mustache syntax: </b>
                <code>&#123;&#123;issue.{value}&#125;&#125;</code>
              </>
            )}
          </Panel>
        </Collapse>
      )}
    </>
  );
};
export default MidSectionConnectionExtension;
